import React,{ Component } from "react";
import {Carousel} from 'antd';
import './index.less'
import Axios from "../../../../components/request/axios";
class Banner extends Component {
    state={
        news:[],
        channel__id:''
    };
    componentDidMount() {
        let _this=this;
        let channel__name='首页轮播图';
        let params={
            channel__name:channel__name
        };
        Axios.get('/api/v1/banner/',params).then((res)=>{
            if(res){
                let news=res.results;
                _this.setState({
                    news:news,
                    channel__id:res.results[0]?res.results[0].channel.split('/')[res.results[0].channel.split('/').length-2]:''
                });
            }
        });
    }
    tonewsShow=(id)=>{
        let channel__id=this.state.channel__id;
        let hash='#/news/newshow?id='+id+"&key="+channel__id+"&banner="+channel__id; ///banner用来判断是否需要显示导航栏内容
        window.location.hash=hash;
    };
    render() {
        let {news}=this.state;
        return <Carousel className='banner' autoplay>
            {news.length>0?
               news.map((item,index)=>{
                   return  <div  key={index} className='news_image_item' onClick={()=>this.tonewsShow(item.id)}>
                       {item.big_image?
                           <div className='image' style={{backgroundImage:'url('+item.big_image.file+')'}} />:
                           <div className='image' >暂无封面</div>
                       }
                       <p>{item.title}</p>
                   </div>
               }):''

            }

           {/* <div className='news_image_item'>
                <div className='image' style={{backgroundImage:'url('+banner+')'}} />
                <p>莫让抽动障碍打破您望子成龙望女成凤的梦</p>
            </div>*/}
        </Carousel>
    }
}
export default Banner